<ng-container *ngIf="page == 'customer-login-page'; else cartLoginPopup">
    <div class="slider-section-login position-relative" *ngIf="isSearchByVehicleDisabled">
        <div class="position-absolute top-50 start-50 translate-middle">
            <app-shop-by-vehicle></app-shop-by-vehicle>
        </div>
    </div>
    <main class="bg-login" [ngStyle]="{'background-image': 'url(' + cdnImagePath + loginPageImage + ')'}">
        <div class="bg-opacity-login">
            <div class="container pb-5">
                <div class="d-flex justify-content-center customer-wrapper mx-2 mx-md-3 mx-lg-4 mb-5  ">
                    <div>
                        <form class="form-wrap customer-bg shadow px-4 py-4 my-5 mx-md-3 " [formGroup]="loginForm"
                            (ngSubmit)="getLoginForm()" [ngClass]="{ submitted: isSubmitClicked }">
                            <h2 class="mb-4 login-txt text-start white-txt">Sign in</h2>
                            <p class="text-danger" id="login-error-msg"></p>
                             <ng-container *ngIf="showSocialMediaOnLogin">
                            <div class="p-0 mb-3" >
                                <div class="col-md-12">
                                    <div class="new-google-auth">
                                        <div class="new-google-btn w-100 d-flex align-items-center pt-1 ps-1 p-start">
                                            <span class="new-google-icon me-2">
                                                <img class="google-img"
                                                    src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg">
                                            </span>
                                            <span class="new-sign-txt">Sign in with Google</span>
                                        </div>
                                        <div id="googleSignInButtonmain" class="google-iframe-layer">
                                            <iframe
                                                src="https://accounts.google.com/gsi/button?theme=outline&size=large&is_fedcm_supported=true&client_id=947339829000-p8le8bvircu0firajq51hn8i61qei8ba.apps.googleusercontent.com"
                                                style="border:none;outline:none;box-shadow:none;width:100%;height:100%;"
                                                allow="identity-credentials-get">
                                            </iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="p-0">
                                <div class="col-md-12 pb-3">
                                    <div class="new-facebook-auth">
                                        <div class="new-fb-btn w-100 d-flex align-items-center pt-1 p-top"
                                            (click)="loginWithFacebook()">
                                            <span class="new-fb-icon me-2">
                                                <i class="fa-brands fa-facebook-f"></i>
                                            </span>
                                            <span class="new-sign-txt">Continue with Facebook</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                           </ng-container>
                            <div class="row align-items-center my-3 p-0">
                                <div class="col-md-12">
                                    <div class="custom-input-wrapper ">
                                        <input type="email" id="email_address" name="email_address"
                                            placeholder="Email Address" formControlName="email_address" required
                                            class="form-control custom-input-group-1 form-bg " />
                                    </div>
                                    <div class="validation-error"
                                        *ngIf="loginForm?.get('email_address')?.hasError('required') &&(loginForm?.get('email_address')?.dirty ||isSubmitClicked)">
                                        Email is required.
                                    </div>
                                    <div class="validation-error"
                                        *ngIf="loginForm?.get('email_address')?.hasError('email') &&!loginForm?.get('email_address')?.hasError('required') &&(loginForm?.get('email_address')?.dirty ||loginForm?.get('email_address')?.touched ||isSubmitClicked) || loginForm?.get('email_address')?.hasError('pattern')">
                                        Invalid email address.
                                    </div>
                                </div>
                            </div>
                            <div class="row align-items-center my-3 p-0">
                                <div class="col-md-12">
                                    <div class="custom-input-wrapper ">
                                        <input type="password" id="password" name="password" placeholder="Password"
                                            formControlName="password" required
                                            class="form-control custom-input-group-1 form-bg" />
                                    </div>
                                    <div class="validation-error"
                                        *ngIf="loginForm?.get('password')?.hasError('required') &&(loginForm?.get('password')?.dirty ||loginForm?.get('password')?.touched ||isSubmitClicked)">
                                        Password is required.
                                    </div>
                                    <div class="validation-error"
                                        *ngIf="loginForm?.get('password')?.hasError('minlength') &&!loginForm?.get('password')?.hasError('required') &&(loginForm?.get('password')?.dirty ||loginForm?.get('password')?.touched ||isSubmitClicked)">
                                        Password must be at least 6 characters.
                                    </div>
                                    <div class="validation-error"
                                        *ngIf="loginForm?.get('password')?.hasError('maxlength') &&!loginForm?.get('password')?.hasError('required') &&(loginForm.get('password')?.dirty ||loginForm?.get('password')?.touched ||isSubmitClicked)">
                                        Password must be a maximum of 30 characters.
                                    </div>
                                    <div class="validation-error" *ngIf="loginError">
                                        Invalid credentials. Please try again.
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 mt-2 text-start pe-0 d-flex align-items-center">
                                    <input type="checkbox" class="form-check-input-1" id="rememberme" name="rememberme"
                                        value="rememberme" formControlName="rememberMe" />
                                    <label for="rememberme" class="form-checked-label ps-2 title-remember white-txt">
                                        Remember me
                                    </label>
                                </div>
                                <div class="col-md-6 text-start custom-padding p-2 p-md-1 mt-1 ms-1 ms-md-0">
                                    <a class="forget-txt-1 mb-0">
                                        <span class="cursor-pointer" [routerLink]="['/forget-password']">
                                            Forgot your password?
                                        </span>
                                    </a>
                                </div>
                            </div>
                            <button type="submit" class="btn d-block login-btn white-txt my-3 mt-3">
                                LOG IN
                            </button>
                            <h4 class="sub-title-1 white-txt">
                                Don’t have an account ?</h4>
                            <div class="mt-2">
                                <a [routerLink]="['/sign-up']" class="sign-up-1">Sign up now</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </main>
    <div class="footer">
        <div class="custmer-footer">
            <app-subscribe></app-subscribe>
        </div>
    </div>
</ng-container>

<ng-template #cartLoginPopup>
    <div class="custom-bg">
        <div class="modal bg-quick-sign show d-block" tabindex="-1" role="dialog" aria-modal="true">
            <div class="modal-dialog modal-dialog-centered justify-content-center modal-md" role="document">
                <div class="modal-content quick-wrapper p-4">
                    <form class="form-wrapper d-block" [formGroup]="loginForm" (ngSubmit)="getLoginForm()"
                        [ngClass]="{ submitted: isSubmitClicked }">
                        <div class="modal-header border-0 pt-0 pb-0 px-0">
                            <h5 class="modal-title quick-txt mb-3">Sign in </h5>
                            <button type="button" class="mb-5 p-0 border-0 red-cross" aria-label="Close"
                                (click)="closePopup()">
                                <img [src]="commonImagePath +closeIcon" alt="red-cross-icon" />
                            </button>
                        </div>
                        <div
                            class="modal-body form-body d-flex flex-column text-center justify-content-center align-item-baseline mt-0 p-0 gap-1">
                            <ng-container *ngIf="showSocialMediaOnLogin">
                            <div class="google-btn-wrapper position-relative">
                                <div class="auth-btn google-auth-btn">
                                    <span class="auth-icon">
                                        <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                                            alt="Google">
                                    </span>
                                    <span class="auth-text">Sign in with Google</span>
                                </div>
                                <div id="googleSignInButton" class="google-iframe">
                                    <iframe
                                        src="https://accounts.google.com/gsi/button?theme=outline&size=large&is_fedcm_supported=true&client_id=947339829000-p8le8bvircu0firajq51hn8i61qei8ba.apps.googleusercontent.com"
                                        style="border:none;outline:none;box-shadow:none;width:100%;height:100%;"
                                        allow="identity-credentials-get">
                                    </iframe>
                                </div>
                                <div class="auth-btn facebook-auth-btn mb-4" (click)="loginWithFacebook()">
                                    <span class="auth-icon">
                                        <i class="fa-brands fa-facebook-f"></i>
                                    </span>
                                    <span class="auth-text">Sign in with Facebook</span>
                                </div>
                            </div>
                            </ng-container>
                            <div class="row align-items-center mb-2 p-0">
                                <div class="col-md-12">
                                    <div class="custom-input-wrapper">
                                        <input type="email" id="email_address" name="email_address"
                                            formControlName="email_address" required
                                            class="form-control custom-input-group custom-input-with-icon"
                                            placeholder="Email Address" />
                                    </div>
                                    <div class="validation-error"
                                        *ngIf="loginForm?.get('email_address')?.hasError('required') &&(loginForm?.get('email_address')?.dirty ||loginForm?.get('email_address')?.touched ||isSubmitClicked)">
                                        Email is required.
                                    </div>
                                    <div class="validation-error"
                                        *ngIf="loginForm?.get('email_address')?.hasError('email') &&!loginForm?.get('email_address')?.hasError('required') &&(loginForm?.get('email_address')?.dirty ||loginForm?.get('email_address')?.touched ||isSubmitClicked)|| loginForm?.get('email_address')?.hasError('pattern')">
                                        Invalid email address.
                                    </div>
                                </div>
                            </div>
                            <div class="row align-items-center mb-2 p-0">
                                <div class="col-md-12">
                                    <div class="custom-input-wrapper">
                                        <input type="password" id="password" name="password" formControlName="password"
                                            required class="form-control custom-input-group custom-input-with-icon"
                                            placeholder="Password" />
                                    </div>
                                    <div class="validation-error"
                                        *ngIf="loginForm?.get('password')?.hasError('required') &&(loginForm?.get('password')?.dirty ||loginForm?.get('password')?.touched ||isSubmitClicked)">
                                        Password is required.
                                    </div>
                                    <div class="validation-error"
                                        *ngIf="loginForm?.get('password')?.hasError('minlength') &&!loginForm?.get('password')?.hasError('required') &&(loginForm?.get('password')?.dirty ||loginForm?.get('password')?.touched || isSubmitClicked)">
                                        Password must be at least 6 characters.
                                    </div>
                                    <div class="validation-error"
                                        *ngIf="loginForm?.get('password')?.hasError('maxlength') &&!loginForm?.get('password')?.hasError('required') &&(loginForm.get('password')?.dirty ||loginForm?.get('password')?.touched ||isSubmitClicked)">
                                        Password must be a maximum of 30 characters.
                                    </div>
                                    <div class="validation-error" *ngIf="loginError">
                                        Invalid credentials. Please try again.
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-md-5 text-start">
                                    <input type="checkbox" class="form-check-input" id="rememberme" name="rememberme"
                                        value="rememberme" formControlName="rememberMe" />
                                    <label for="rememberme" class="form-check-label ps-1 txt-remember">
                                        Remember me
                                    </label>
                                </div>
                                <div class="col-md-7 text-start">
                                    <a class="forget-txt mb-1">
                                        <span class="cursor-pointer" [routerLink]="['/forget-password']"
                                            (click)="closePopup()">
                                            Forgot your password?
                                        </span>
                                    </a>
                                </div>
                            </div>
                            <div class="row p-0 mt-3">
                                <div class="col-12 text-start mb-3">
                                    <button type="submit" class="btn login-btn">LOG IN</button>
                                </div>
                            </div>
                            <div class="row mb-3 align-items-start text-start p-0">
                                <div class="col-md-12">
                                    <h4 class="sub-title">Don’t have an account ?</h4>
                                    <div class="mt-2">
                                        <a [routerLink]="['/sign-up']" class="sign-up" (click)="closePopup()">Sign up
                                            now</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</ng-template>